import styled from 'styled-components';

import { flexCenterAligned, flexRow } from '@/styles/common';

export const Container = styled.div`
  width: 100%;
  max-width: 239px;
  padding: 8px 20px 8px 8px;
  background-color: var(--toast-bg-main);
  border-radius: 30px;
  ${flexRow}
  align-items: center;
  gap: 10px;
  color: var(--toast-text-main);
`;

export const Icon = styled.div`
  width: 44px;
  aspect-ratio: 1 / 1;
  border: 1px solid var(--toast-border-main);
  color: var(--toast-text-main);
  border-radius: 50%;
  ${flexCenterAligned}
`;
